export default function ColumnPrimitive(overlay, ctx, layout, data) {

    const green = data.raw[4] >= data.raw[1]
    const color = green ? overlay.upColor : overlay.downColor

    let w = Math.max(data.w * 0.7, 1)
    let hw = Math.max(Math.floor(w * 0.5), 1)
    let x05 = Math.floor(data.x) - 0.5

    // Columns draw from high to low as a solid bar
    let top = Math.floor(data.h)
    let bottom = Math.floor(data.l)
    let height = bottom - top

    if (data.w > 1.5) {
        ctx.fillStyle = color
        ctx.fillRect(
            Math.floor(data.x - hw - 1),
            top,
            Math.floor(hw * 2 + 1),
            Math.max(height, 1)
        )
    } else {
        ctx.strokeStyle = color
        ctx.beginPath()
        ctx.moveTo(x05, top)
        ctx.lineTo(x05, bottom)
        ctx.stroke()
    }
}
